<template>
  <div>
     <div id="modal" class="modal">
       <div class="modal-mask">
        <div class="modal-wrapper">
          <div class="modal-container ">
              <div class="modal-header">
                <slot name="header">
                  <h3>Inicio de Sesión </h3>
                </slot>
              </div>

              <div class="modal-body">
                <slot name="body">
                  <div class="campo">
                    <label class="items">Usuario</label>
                    <input class="items"type="text" name="Usuario" v-model="input.usuario" placeholder="Usuario"required="">
                  </div>
                  <div class="campo">
                    <label class="items">Contraseña</label>
                    <input type="password" class="items" name="Contraseña" v-model="input.contrasenia" placeholder="Contraseña" required="">
                  </div>
                 
                </slot>
              </div>

              <div class="modal-footer">
                <slot name="footer">
                  <button class="modal-default-button"  @click.prevent="logIn">
                    Login
                  </button>
                  <button class="modal-default-button" @click="back">
                      Cancelar
                  </button> 
                  
                </slot>
              </div>

          </div> 
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import cabecera from '../components/cabecera.vue'
import pie from '../components/pie.vue'

import store from '../store'
import axios from 'axios'


export default {
  name: 'registro',
  components: {
    cabecera, 
    pie, 
  },
  data: function(){
    return {
      input: {
          usuario: "",
          contrasenia: ""
      },
      datos:[]
    }
  },
  computed: {
    menuActive () {
      return store.state.menuActive
    }, 
    login () {
      return store.state.login
    },

  },
  methods:{
    back(){
      this.$router.push('/aplicacion')
      
    },
    logIn () {

      if(this.input.usuario!="" && this.input.contrasenia!=""){
          axios.get('http://cimogsys.espoch.edu.ec:3000/api/usuario/'+this.input.usuario)
          // axios.get('http://localhost:3000/api/usuario/'+this.input.usuario)

           .then(response => {
              if (response.status === 200){
                if(this.input.contrasenia==response.data.data.contrasenia_usuario){
                  console.log(response.data.data)
                  store.commit('LOGIN', [this.datos.nombre_usuario, this.datos.contrasenia_usuario])
                  this.$router.push('/gestion')
                }
                else{
                  alert("Verifique sus credenciales");
                }
              }
            })
            .catch(e => {
                alert("Verifique sus credenciales");
            })
         }
         else{
            alert("Complete los campos");
         }
        },
    

  }

}
</script>
</script>
<style  lang="scss"  scoped src="../sass/formulario.scss"></style>



// WEBPACK FOOTER //
// src/components/login.vue